module.exports = __webpack_public_path__ + "img/bg3.702e83cb.png";